import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { reportService } from '../../services/reportService';

export const useGetTaxReports = params => {
  return useQuery({
    staleTime: Infinity,
    queryKey: [QUERY_KEYS.report.tax_report, params],
    queryFn: () =>
      reportService.taxReports(params).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
